export default __webpack_public_path__ + "static/media/edit.bc33e42d.svg";